import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const audioMessage = {
  createAudioMessage: lazyModuleMethod(
    () => import('./createAudioMessage'),
    'default'
  ),
  deleteAudioMessage: lazyModuleMethod(
    () => import('./deleteAudioMessage'),
    'default'
  ),
  fetchAudioMessage: lazyModuleMethod(
    () => import('./fetchAudioMessage'),
    'default'
  ),
  fetchAudioMessages: lazyModuleMethod(
    () => import('./fetchAudioMessages'),
    'default'
  ),
  fetchDeletedAudioMessages: lazyModuleMethod(
    () => import('./fetchDeletedAudioMessages'),
    'default'
  ),
  restoreAudioMessage: lazyModuleMethod(
    () => import('./restoreAudioMessage'),
    'default'
  ),
  updateAudioMessage: lazyModuleMethod(
    () => import('./updateAudioMessage'),
    'default'
  ),
  uploadAudioToAudioMessage: lazyModuleMethod(
    () => import('./uploadAudioToAudioMessage'),
    'default'
  ),
}
